import {
  parseGlobalLinkFromCMS,
  parseImageFromCMS,
} from '@/lib/contentstack-sdk/utils/parseHelpers';
import { OrMiniCtaBlockD } from './or-mini-cta-block-d';
import {
  IImageGlobalCSProps,
  IMiniCtaBlockDCMSProps,
} from '@/lib/contentstack-sdk/types/component';

export const OrMiniCtaBlockDCMS = (props: IMiniCtaBlockDCMSProps) => {
  const {
    top_spacing,
    bottom_spacing,
    heading_variant,
    heading_element,
    heading,
    cta_button_top,
    cta_button_bottom,
    theme,
    body_copy,
    cta_image,
  } = props;

  const imageProps = parseImageFromCMS(cta_image as IImageGlobalCSProps);
  const topCTA = parseGlobalLinkFromCMS(cta_button_top, 'mini-cta-block-d');
  const bottomCTA = parseGlobalLinkFromCMS(
    cta_button_bottom,
    'mini-cta-block-d',
  );

  return (
    <OrMiniCtaBlockD
      top_spacing={top_spacing.spacing_value}
      bottom_spacing={bottom_spacing.spacing_value}
      heading_element={heading_element.select}
      heading_variant={heading_variant.select}
      heading={heading}
      theme={theme.theme}
      image={imageProps!}
      body_copy={body_copy}
      top_cta={topCTA}
      bottom_cta={bottomCTA}
      top_divider={top_spacing.divider}
      bottom_divider={bottom_spacing.divider}
    />
  );
};
